var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-upload',_vm._g(_vm._b({attrs:{"name":"Attachment","action":_vm.BASEURL+'api/annex/uploads',"data":{path:'file'},"list-type":"text","file-list":_vm.fileList},on:{"change":_vm.handleUpload}},'a-upload',_vm.$attrs,false),_vm.$listeners),[_c('a-button',[_c('a-icon',{attrs:{"type":"upload"}}),_vm._v(" 点击上传")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }